import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { Experience } from '../types/Experience';
import { ExperienceListItem } from './ExperienceListItem';
interface ExperienceCategorySectionProps {
  category: string;
  experiences: Experience[];
  selectedExperienceId: string | null;
  onSelectExperience: (id: string) => void;
}
export function ExperienceCategorySection({
  category,
  experiences,
  selectedExperienceId,
  onSelectExperience
}: ExperienceCategorySectionProps) {
  const [isExpanded, setIsExpanded] = useState(true);
  return <div className="border-b border-gray-100" data-id="element-52">
      <button onClick={() => setIsExpanded(!isExpanded)} className="w-full flex items-center justify-between py-3 px-4 text-left hover:bg-gray-50 transition-colors" data-id="element-53">
        <h3 className="text-sm font-medium text-gray-900" data-id="element-54">{category}</h3>
        <ChevronDown size={16} className="text-gray-400 transition-transform" style={{
        transform: isExpanded ? 'rotate(0deg)' : 'rotate(-90deg)'
      }} strokeWidth={1.5} data-id="element-55" />
      </button>
      {isExpanded && <div data-id="element-56">
          {experiences.map(experience => <ExperienceListItem key={experience.id} experience={experience} isSelected={experience.id === selectedExperienceId} onClick={() => onSelectExperience(experience.id)} data-id="element-57" />)}
        </div>}
    </div>;
}